export function JSONObjectMutations() {
  /*******************************************************************************
   * JSON.postTo */
  /**
   * @ngdoc    method
   * @name     postTo
   * @methodOf polyfill.JSON
   * @param    {object} data      JSON data to post
   * @param    {string} url       Target Url
   * @param    {string} inputName Payload name for JSON data. Default="data"
   * @param    {string} target    Response target. Default="_blank"
   * @param    {string} ct        Content Type. Default=application/x-www-form-urlencoded
   * @description
   * This static method will allow a JSON object to be posted to a page by generating
   * a form and using the appropriate target value.
   *******************************************************************************/
  JSON.postTo = function (data, url, inputName, target, ct) {
    /*--------------------*/
    /* Build form to post */
    /*--------------------*/
    var form = angular.element("<form method='POST'>");
    form.attr('action', url);
    form.attr('target', target || '_blank');
    form.attr('enctype', ct || 'application/x-www-form-urlencoded');

    /*--------------------------*/
    /* Create the payload input */
    /*--------------------------*/
    var input = angular.element("<input type='text'>");
    input.attr('name', inputName || 'data');
    input.attr('value', JSON.stringify(data));
    form.append(input);

    /*---------------*/
    /* Post the form */
    /*---------------*/
    var body = document.querySelector('body');
    body.appendChild(form[0]);
    form[0].submit();
    body.removeChild(form[0]);
  };
}
